import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";

import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import {} from // Edit,
// ChevronUp,
// Eye,
// Eye,
// RotateCcw,
"feather-icons-react/build/IconComponents";
// import { setToogleHeader } from "../../../../../core/redux/action";

import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { BASE_CRM_URL } from "../../../../components/config/config";
import Table from "../../../../../core/pagination/datatable";
import { Select, Spin } from "antd";
import dayjs from "dayjs";
import Swal from "sweetalert2";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const CreditNotes = () => {
  // const dataSource = useSelector((state) => state.rootReducer.CRMCreditNote);

  // const dispatch = useDispatch();
  // const data = useSelector((state) => state.rootReducer.toggle_header);
  //   //   const route = all_routes;

  const formatValue = (text) => {
    if (text === null || text === undefined || text === "") {
      return "-";
    }

    return text.toString().length > 15
      ? `${text.toString().substring(0, 15)}...`
      : text.toString();
  };

  const [creditNoteStatusOptions, setCreditNoteStatusOptions] = useState([]);

  const getCreditNoteStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}creditnotes/GetCreditNoteStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.CreditNoteStatus,
        }));

        setCreditNoteStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "credit_note_number",
      sorter: (a, b) =>
        (a.credit_note_number || "").localeCompare(b.credit_note_number || ""),
      render: (text, record) => (
        <Link to={`/crm/view/creditnote`} state={{ record }}>
          {formatValue(text)}
        </Link>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      render: (text) => (
        <>
          <i className="fa-regular fa-calendar me-2 text-primary"></i>
          {text ? dayjs(text).format("DD-MM-YYYY") : "N/A"}
        </>
      ),
    },
    {
      title: "Customer",
      dataIndex: "cutomer_name",
      render: (text) => (
        <>
          <i className="fa-regular fa-user me-2 text-info"></i>
          <span title={text || "-"}>
            {text
              ? text.length > 30
                ? `${text.substring(0, 30)}...`
                : text
              : "N/A"}
          </span>
        </>
      ),
    },
    {
      title: "Reference",
      dataIndex: "reference_no",
      sorter: (a, b) =>
        (a.reference_no || "").localeCompare(b.reference_no || ""),
      render: (text) => formatValue(text),
    },
    // {
    //   title: "Amount",
    //   dataIndex: "amount",
    //   sorter: (a, b) => Number(a.amount || 0) - Number(b.amount || 0),
    //   render: (text) => {
    //     if (text === null || text === undefined || text === "") {
    //       return "N/A";
    //     }

    //     return `₹ ${Number(text).toLocaleString("en-IN")}`;
    //   },
    // },

    {
      title: "Amount",
      dataIndex: "amount",

      render: (amount) => (
        <span className="fw-bold text-success">
          <i className="fa-solid fa-indian-rupee-sign me-2"></i>
          {amount}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Close":
              return "#dc3545";
            case "Open":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              creditNoteStatusOptions.find((item) => item.label === text)?.value
            }
            style={{ width: 100 }}
            options={creditNoteStatusOptions}
            onChange={(value) => {
              updateCreditNoteStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = creditNoteStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },
    {
      title: "CreatedBy",
      dataIndex: "added_by",
      sorter: (a, b) => (a.added_by || "").localeCompare(b.added_by || ""),
      render: (text) => formatValue(text || "N/A"),
    },

    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (_, record) => (
        <>
          {/* <Link className="action-set" to="#" data-bs-toggle="dropdown">
            <i className="fa fa-ellipsis-v btn border"></i>
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                className="dropdown-item"
                to={`/crm/view/creditnote`}
                state={{ record }}
              >
                <Eye className="me-2 text-info" />
                View
              </Link>
            </li>
            <li>
              <Link
                to={`/crm/update/creditnote/${record.id}`}
                className="dropdown-item"
              >
                <Edit className="me-2 text-primary" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                title="Edit"
                to={`/crm/update/creditnote/${record.id}`}
                className="text-primary me-2 p-2"
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  // const renderCollapseTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Collapse
  //   </Tooltip>
  // );
  // const multiselectOptions = [
  //   { label: "All", value: "all" },
  //   { label: "Open", value: "open" },
  //   { label: "Closed", value: "closed" },
  //   { label: "Void", value: "void" },
  //   { label: "2025", value: "2025" },
  //   { label: "2024", value: "2024" },
  //   { label: "2023", value: "2023" },
  //   { label: "2022", value: "2022" },
  //   { label: "2021", value: "2021" },
  //   { label: "2020", value: "2020" },
  // ];
  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  // const renderRefreshTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Refresh
  //   </Tooltip>
  // );

  const updateCreditNoteStatus = async (cerditId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}creditnotes/UpdateCreditNoteStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: cerditId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });

        getCreditNotes();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [creditNotesData, setCreditNotesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  console.log(creditNotesData, loading);

  const getCreditNotes = async () => {
    try {
      setLoading(true);

      const response = await fetch(`${BASE_CRM_URL}creditnotes/GetCreditNotes`);

      const data = await response.json();

      console.log(data, "dataaaaaaaaaaaaaa"); // Check the response

      if (data.Status) {
        setCreditNotesData(data.Data);
      }
    } catch (error) {
      console.error("Error fetching credit notes:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCreditNotes();
    getCreditNoteStatuses();
  }, []);
  const exportExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("CreditNote");

      // Columns
      worksheet.columns = [
        { header: "CreditNote#", key: "credit_note_number", width: 25 },
        { header: "Company", key: "cutomer_name", width: 25 },
        { header: "Project", key: "project_name", width: 32 },
        { header: "Amount", key: "amount", width: 18 },
        { header: "Created", key: "date", width: 18 },
        { header: "Assigned", key: "added_by", width: 18 },
        { header: "Status", key: "StatusName", width: 18 },
      ];

      // Add data
      creditNotesData.forEach((creditNotesData) => {
        worksheet.addRow({
          credit_note_number: creditNotesData.credit_note_number ?? "",
          cutomer_name: creditNotesData.cutomer_name ?? "",
          project_name: creditNotesData.project_name ?? "",
          amount: creditNotesData.amount ?? "",
          date: creditNotesData.date ?? "",
          added_by: creditNotesData.added_by ?? "",

          StatusName: creditNotesData.StatusName || "N/A",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      headerRow.height = 22;

      // Borders and alignment
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Creditnote.xlsx");
    } catch (error) {
      console.error("Excel export error:", error);

      Swal.fire("Error", "Failed to generate Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "CReditNote#",
        "Company",
        "Project",
        "Amount",
        "Created",
        "Assigned",
        "Status",
      ];

      const rows = creditNotesData.map((creditNotesData) => [
        creditNotesData.credit_note_number ?? "",
        creditNotesData.cutomer_name ?? "",
        creditNotesData.project_name ?? "",

        creditNotesData.amount ?? "",
        creditNotesData.date ?? "",
        creditNotesData.added_by ?? "",

        creditNotesData.StatusName || "N/A",

        // estimate.dateadded
        //   ? new Date(estimate.dateadded).toLocaleString("en-IN")
        //   : "",
      ]);

      // Report title - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("creditNote Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 6,
          right: 6,
        },

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        didDrawPage: () => {
          // Footer center
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Total pages
      const totalPages = doc.internal.getNumberOfPages();

      // Page X of Y
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("CreditNote.pdf");
    } catch (error) {
      console.error("PDF export error:", error);

      Swal.fire("Error", "Failed to generate PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      {exportLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/Dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Credit Notes
                  </h4>
                </ol>
              </nav>
              <h6>Manage your Credit Notes here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link onClick={exportPDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={exportExcel}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>

            {/* <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li> */}
            {/* <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li> */}
          </ul>
          <div className="page-btn">
            <Link to="/crm/add/creditnote" className="btn btn-success btn-sm">
              <i className="ti ti-circle-plus fs-4"></i>
            </Link>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set py-3"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              {/* <div className="dropdown me-2">
                <Link
                  to="#"
                  className="d-inline-flex btn btn-md btn-white align-items-center"
                  data-bs-toggle="dropdown"
                >
                  <i className="ti ti-filter me-1"></i>
                </Link>
                <ul className="dropdown-menu dropdown-menu-end p-3">
                  {multiselectOptions.map((option) => (
                    <li key={option.value}>
                      <Link to="#" className="dropdown-item rounded-1">
                        {option.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div> */}
            </div>
          </div>
          <div className="card-body p-0">
            <div className="table-responsive">
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={creditNotesData} />
              )}
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default CreditNotes;
